<template>
  <div class="page-main">
    <el-row style="margin-top: 10px">
      <el-form ref="form" :model="searchForm" class="search-form">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item
              align="right"
              style="margin-bottom: 0px !important"
            ></el-form-item>
            <div style="display: flex">
              <el-select
                v-model="searchForm.type"
                placeholder="请选择"
                style="margin-right: 10px"
                @change="queryFiles"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-input
                placeholder="输入关键字"
                v-model="searchForm.name"
                class="input-with-select"
                clearable
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="queryFiles"
                  >搜索</el-button
                >
              </el-input>
            </div>
          </el-col>
          <el-col :span="16" align="right" v-if="!recycleBinView">
            <el-button @click="handleCreateFold">新建</el-button>
            <el-button @click="handleUploadFile">上传</el-button>
            <el-button @click="handleCompress">在线压缩</el-button>
            <el-button @click="allDownload">批量下载</el-button>
            <el-button @click="batchDelete">批量删除</el-button>
            <el-button @click="queryFiles">刷新</el-button>
            <el-button @click="viewsSwitchingFn">视图切换</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <div
      style="margin-bottom: 10px;margin-top: 20px;display: flex;justify-content: space-between;align-items: center"
    >
      <div>
        <el-link
          class="buttonText"
          @click="searchByAbsolutePath(files.homePath)"
          type="primary"
          :underline="true"
          >主目录</el-link
        >
        <el-link
          v-if="files.prevPath"
          class="buttonText"
          @click="searchByAbsolutePath(files.prevPath)"
          type="primary"
          :underline="true"
          >|上一级|</el-link
        >
        <span v-for="(item, i) in files.paths">
          <span v-if="i === files.paths.length - 1">{{ item }}</span>
          <span v-if="i != files.paths.length - 1"
            ><el-link
              class="buttonText"
              @click="searchByPath(item, i)"
              type="primary"
              :underline="true"
              >{{ item }}</el-link
            >/</span
          >
        </span>
      </div>
      <div>
        <i
          v-if="!recycleBinView"
          class="el-icon-delete-solid"
          style="font-size: 30px; cursor: pointer;"
          @click="showRecycleBin"
          title="回收站"
        >
        </i>
        <i
          v-else
          class="el-icon-close"
          style="font-size: 30px; cursor: pointer;"
          @click="hideRecycleBin"
          title="关闭回收站"
        >
        </i>
      </div>
    </div>
    <el-table
      v-show="!viewsSwitching && !recycleBinView"
      :row-key="getRowId"
      :row-class-name="tableRowClassName"
      v-loading="loading"
      element-loading-text="拼命加载中..."
      element-loading-spinner="el-icon-loading"
      ref="fileTables"
      :data="files.data"
      border
      style="width: 100%"
      :default-sort="{ prop: 'jobId', order: 'descending' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true">
      </el-table-column>
      <!--      <el-table-column label="拖拽" align="center" width="50">-->
      <!--        <template slot-scope="scope">-->
      <!--          <i class="el-icon-rank move" style="cursor: move;"></i>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column prop="name" label="文件名" align="left">
        <template slot-scope="scope">
          <div draggable="true" class="file-name-draggable">
            <i v-if="scope.row.type === 'FOLD'" class="el-icon-folder"></i>
            <i v-if="scope.row.type === 'FILE'" class="el-icon-document"></i>
            <span
              v-if="scope.row.type === 'FILE' && !isSlurm(scope.row.name)"
              >{{ scope.row.name }}</span
            >
            <el-link
              v-if="scope.row.type === 'FOLD'"
              class="buttonText"
              @click="queryFilesByPath(scope.row)"
              type="primary"
              >{{ scope.row.name }}</el-link
            >
            <span
              v-if="isSlurm(scope.row.name)"
              @click="changeFn(scope.row)"
              class="is-slurm"
              >{{ scope.row.name }}</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="fileSize" label="文件大小" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.type === "FILE" ? scope.row.fileSizeStr : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="atime" label="修改时间" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.atime | formatDate("yyyy-MM-dd HH:mm:ss") }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" width="200" label="操作">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            content="下载"
            placement="bottom"
          >
            <!--  v-if="scope.row.type === 'FILE'"-->
            <i
              style="cursor: pointer"
              @click="handleDownload(scope.row)"
              class="el-icon-download"
              >下载</i
            >
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="light"
            content="重命名"
            placement="bottom"
          >
            <i
              title="重命名"
              style="cursor: pointer"
              @click="handleNewName(scope.row)"
              class="el-icon-edit"
              >重命名</i
            >
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="light"
            content="删除"
            placement="bottom"
          >
            <i
              title="删除"
              style="cursor: pointer"
              @click="handleDelete(scope.row)"
              class="el-icon-delete"
              >删除</i
            >
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 回收站表格 -->
    <el-table
      v-show="recycleBinView"
      :data="recycleBinData"
      border
      style="width: 100%"
      v-loading="recycleBinLoading"
    >
      <el-table-column prop="name" label="文件名" align="left">
        <template slot-scope="scope">
          <div>
            <i v-if="scope.row.type === 'FOLD'" class="el-icon-folder"></i>
            <i v-if="scope.row.type === 'FILE'" class="el-icon-document"></i>
            <span>{{ scope.row.fileName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="deleteTime" label="删除时间">
        <template slot-scope="scope">
          <span>{{ scope.row.gmtCreateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="originalPath" label="原路径" align="left">
        <template slot-scope="scope">
          <span>{{ scope.row.pathName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="restoreFile(scope.row, true)"
            >还原</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="restoreFile(scope.row, false)"
            >彻底删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 切换视图 -->
    <div class="switch" v-show="viewsSwitching && !recycleBinView">
      <!-- {{ files.data }} -->
      <el-card
        class="switch-item"
        :body-style="{ padding: '0px', position: 'relative' }"
        v-for="(item, index) in files.data"
        :key="item.name"
      >
        <div class="check">
          <el-checkbox
            v-model="item.isCheck"
            @change="e => changeCheck(e, index)"
          ></el-checkbox>
        </div>
        <div class="icon">
          <i v-if="item.type === 'FOLD'" class="el-icon-folder icon-size"></i>
          <i v-if="item.type === 'FILE'" class="el-icon-document icon-size"></i>
          <span
            v-if="item.type === 'FILE' && !isSlurm(item.name)"
            style="display: block"
            >{{ item.name }}</span
          >
          <el-link
            v-if="item.type === 'FOLD'"
            class="buttonText"
            @click="queryFilesByPath(item)"
            type="primary"
            style="display: block; text-decoration: none"
            >{{ item.name }}</el-link
          >
          <span
            v-if="isSlurm(item.name)"
            @click="changeFn(item)"
            class="is-slurm"
            >{{ item.name }}</span
          >
        </div>

        <div style="padding: 14px">
          <div class="bottom clearfix switch-item-bottom">
            <el-tooltip
              class="item"
              effect="light"
              content="下载"
              placement="bottom"
            >
              <!--  v-if="item.type === 'FILE'"-->
              <i
                style="cursor: pointer"
                @click="handleDownload(item)"
                class="el-icon-download"
                >下载</i
              >
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              content="重命名"
              placement="bottom"
            >
              <i
                title="重命名"
                style="cursor: pointer; margin: 0 5px"
                @click="handleNewName(item)"
                class="el-icon-edit"
                >重命名</i
              >
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              content="删除"
              placement="bottom"
            >
              <i
                title="删除"
                style="cursor: pointer"
                @click="handleDelete(item)"
                class="el-icon-delete"
                >删除</i
              >
            </el-tooltip>
          </div>
        </div>
      </el-card>
    </div>

    <el-pagination
      v-show="!recycleBinView"
      align="center"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="files.currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="files.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="files.total"
    >
    </el-pagination>
    <create-fold
      ref="createFoldRef"
      @handleCreateSuccess="handleCreateFileFoldSuccess"
    ></create-fold>
    <sftp-file-upload
      ref="fileUploadRef"
      @handleUploadSuccess="handleUploadSuccess"
      @handleUploadClosed="handleUploadClosed"
    ></sftp-file-upload>

    <el-dialog
      title="重命名"
      :visible.sync="newName"
      :close-on-click-modal="false"
    >
      <el-form ref="formName" :model="newNameForm" :rules="rules">
        <el-form-item label="旧名称" :label-width="formLabelWidth">
          <el-input
            :disabled="true"
            v-model="newNameForm.oldFileName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="重命名"
          :label-width="formLabelWidth"
          prop="newFileName"
        >
          <el-input
            v-model.trim="newNameForm.newFileName"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="noEditFn(0)">取 消</el-button>
          <el-button type="primary" @click="editFn(1)">确 定</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>

    <el-dialog
      :visible="shellDetailVisible"
      width="60%"
      @close="closeShellDetailVisible"
    >
      <shell-code-mirror ref="shellCodeMirrorRef"></shell-code-mirror>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeShellDetailVisible">取 消</el-button>
        <el-button type="primary" @click="openShellDetailVisible"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible="compressionDialog"
      @close="compressionDialog = false"
      title="在线压缩"
      width="40%"
      class="compression-dialog"
    >
      <div class="file-list">
        <span class="label">已选文件名称：</span>
        <el-tag
          v-for="(item, index) in compressionList"
          :key="item.name"
          class="file-tag"
          size="small"
          closable
          @close="removeFileFromCompressionList(index)"
        >
          {{ item.name }}
        </el-tag>
      </div>
      <div class="fileName" style="display: flex">
        <span class="label">压缩包名称：</span>
        <el-input
          v-model="compressQuery.compressionName"
          placeholder="请输入压缩包名称"
          required
        ></el-input>
      </div>
      <div class="switch-container">
        <span class="label">是否保留原文件：</span>
        <el-switch
          v-model="compressQuery.switchCompression"
          active-text="是"
          inactive-text="否"
        >
        </el-switch>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="compressionDialog = false">取 消</el-button>
        <el-button type="primary" @click="compressionFn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import fetch from "../../../comm/api/fetch";
import CreateFold from "./CreateFold";
import SftpFileUpload from "./SftpFileUpload";
import ShellCodeMirror from "../../../workspace/components/self-code-mirrors/shell-code-mirror";
export default {
  name: "file-transfer",
  components: {
    CreateFold,
    SftpFileUpload,

    ShellCodeMirror
  },
  data() {
    const checkIdCard = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("不能为空"));
      }
      if (/^[a-zA-Z0-9_-]*$/.test(value)) {
        callback();
      } else {
        callback("不能包含除_和-之外所有的特殊字符，且文件名不能为空");
      }
    };
    return {
      selectedFiles: new Map(),
      options: [
        {
          value: null,
          label: "全部"
        },
        {
          value: "FILE",
          label: "文件"
        },
        {
          value: "FOLD",
          label: "文件夹"
        }
      ],
      compressionDialog: false,
      multipleSelection: [],
      files: {
        data: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        homePath: undefined,
        prevPath: undefined,
        paths: undefined,
        currentPath: undefined
      },
      multipleSelectionList: [],
      compressQuery: {
        compressionName: undefined,
        switchCompression: true
      },
      searchForm: {
        name: undefined,
        type: null
      },
      newName: false,
      newNameForm: {
        path: "",
        oldFileName: "",
        newFileName: ""
      },
      formLabelWidth: "100",
      loading: false,
      viewsSwitching: false,
      shellDetailVisible: false,
      shellParams: null,
      compressionList: [],
      isDragging: false, // 是否拖拽
      rules: {
        newFileName: [
          {
            required: true,
            message: "文件夹名称不为空",
            trigger: "blur"
          },
          { validator: checkIdCard, trigger: "blur" }
        ]
      },
      fileExtension: null,
      recycleBinView: false, // 回收站视图控制
      recycleBinData: [], // 回收站数据
      recycleBinLoading: false // 回收站加载状
    };
  },
  mounted() {
    this.viewsSwitching = JSON.parse(localStorage.getItem("viewsSwitching"));
    // console.log(this.viewsSwitching);
    this.$nextTick(() => {
      setTimeout(() => {
        this.initDragAndDrop();
      }, 500);
    });
  },
  methods: {
    openShellDetailVisible() {
      // console.log(this.$refs.shellCodeMirrorRef);
      let e = this.shellParams;
      let data = this.$refs.shellCodeMirrorRef.currCode;
      // console.log(this.$refs.shellCodeMirrorRef.currCode);
      this.http
        .post("/client/file/updateFile", {
          path: e.path,
          fileName: e.name,
          fileContent: this.$refs.shellCodeMirrorRef.currCode
        })
        .then(res => {
          // console.log(res);
          if (res.data.success) {
            this.$message({
              message: "恭喜你，修改成功",
              type: "success"
            });
            this.shellDetailVisible = false;
            this.queryFiles();
          }
        });
    },
    changeFn(e) {
      // console.log(e);
      this.shellParams = e;
      this.shellDetailVisible = true;
      this.http
        .post("/v1.0/file/content?path=" + e.path + "&fileName=" + e.name, {})
        .then(res => {
          // console.log(res);
          this.$refs.shellCodeMirrorRef.initCodeValue(res.data);
          this.$refs.shellCodeMirrorRef.cmOptions.readOnly = false;
        });
    },
    getRowId(row) {
      return row.name;
    },
    closeShellDetailVisible() {
      this.shellDetailVisible = false;
    },
    isSlurm(e) {
      return e.substring(e.lastIndexOf(".") + 1) == "slurm";
    },
    changeCheck(e, item) {
      const file = this.files.data[item];
      if (e) {
        this.selectedFiles.set(file.name, file);
      } else {
        this.selectedFiles.delete(file.name);
      }
      this.files.data = JSON.parse(JSON.stringify(this.files.data));
    },
    viewsSwitchingFn() {
      this.viewsSwitching = !this.viewsSwitching;
      window.localStorage.setItem(
        "viewsSwitching",
        JSON.stringify(this.viewsSwitching)
      );
      // 视图切换完成后重新初始化拖拽
      this.$nextTick(() => {
        setTimeout(() => {
          this.initDragAndDrop();
        }, 500);
      });
    },

    allDownload() {
      const MAX_DOWNLOAD_SIZE = 1 * 1024 * 1024 * 1024;
      let data = [];
      if (this.viewsSwitching) {
        this.selectedFiles.forEach(file => {
          data.push(file);
        });
      } else {
        data = this.multipleSelection;
      }
      // console.log(data);
      let arr = [];
      let path = null;
      data.map(res => {
        arr.push(res.name);
      });
      if (arr.length == 0) {
        this.$notify({
          title: "警告",
          message: "请选择文件 | 文件夹",
          type: "warning",
          duration: 2000
        });
        return;
      }
      const totalSize = data.reduce((sum, file) => {
        if (file.type === "FILE") {
          return sum + file.fileSize;
        }
        return sum;
      }, 0);

      if (totalSize > MAX_DOWNLOAD_SIZE) {
        this.$notify({
          title: "下载失败",
          message: "批量下载的文件总大小不能超过1GB",
          type: "error",
          duration: 2000
        });
        return;
      }
      path = data[0].path;
      let params = {
        path: path,
        fileNames: arr
      };
      this.http
        .post("/client/file/packageDownload", params, { responseType: "blob" })
        .then(res => {
          // console.log(res);
          let blob = res.data;
          let title = res.headers["content-disposition"].split("filename=")[1];
          const download_url = window.URL.createObjectURL(blob);
          const eleLink = document.createElement("a");
          eleLink.href = download_url;
          eleLink.download = title;
          document.body.appendChild(eleLink);
          eleLink.click();
          window.URL.revokeObjectURL(download_url);
        });
    },
    editFn(e) {
      this.$refs["formName"].validate(valid => {
        if (valid) {
          if (e) {
            this.loading = true;
            // console.log(this.newNameForm);
            if (this.fileExtension && this.fileExtension.indexOf(".") >= 0) {
              this.newNameForm.newFileName =
                this.newNameForm.newFileName + this.fileExtension;
              this.newNameForm.oldFileName =
                this.newNameForm.oldFileName + this.fileExtension;
            }

            fetch({
              url: `/client/file/fileReName`,
              method: "post",
              params: { ...this.newNameForm },
              encrypt: "no"
            }).then(res => {
              // debugger
              // console.log(res);

              this.loading = false;

              if (res.success) {
                this.$message({
                  message: "恭喜你，修改成功",
                  type: "success"
                });
              } else {
                this.$message({
                  message: res.data,
                  type: "error"
                });
              }

              this.queryFiles();
            });
          }
        } else {
          return false;
        }

        this.newName = false;
        this.fileExtension = null;
      });
    },
    noEditFn() {
      this.newName = false;
      this.$refs["formName"].resetFields();
    },
    handleNewName(e) {
      // console.log(e);
      this.newName = true;
      let showName = null;
      let index = e.name.lastIndexOf(".");
      // console.log(index);
      if (index == -1) {
        showName = e.name;
      } else {
        showName = e.name.slice(0, index);

        this.fileExtension = e.name.slice(index);
        // console.log(this.fileExtension);
      }
      let obj = {
        path: e.path,
        oldFileName: showName,
        newFileName: showName
      };
      this.newNameForm = obj;
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    ansySelect() {
      // 重新设置选中状态
      this.$nextTick(() => {
        this.files.data.forEach(row => {
          const isSelected = this.multipleSelection.some(
            item => item.name === row.name
          );
          if (isSelected) {
            this.$refs.fileTables.toggleRowSelection(row, true);
          }
        });
      });
    },
    handleSizeChange(val) {
      this.files.pageSize = val;
      this.files.page = 1;
      this.files = JSON.parse(JSON.stringify(this.files));
      this.queryFiles();
    },
    handleCurrentChange(val) {
      this.files.currentPage = val;
      this.queryFiles();
    },
    queryFiles() {
      this.http
        .post(
          "/client/file/page?pageSize=" +
            this.files.pageSize +
            "&page=" +
            this.files.currentPage,
          this.searchForm
        )
        .then(res => {
          if (res && res.data.data.rows) {
            this.files.data = res.data.data.rows;
            this.files.total = res.data.data.total;
            this.files.homePath = res.data.homePath;
            this.files.prevPath = res.data.prevPath;
            this.files.currentPath = res.data.currentPath;
            this.files.paths = res.data.paths;
            //给所有加上点击事件的参数
            this.files.data.forEach(file => {
              file.isCheck = this.selectedFiles.has(file.name); // 根据全局存储设置 isCheck
            });

            this.ansySelect();
            // 数据加载完成后重新初始化拖拽
            this.$nextTick(() => {
              setTimeout(() => {
                this.initDragAndDrop();
              }, 500);
            });
            // console.log(this.files.data);
          } else {
            this.restFiles();
          }
        });
    },
    queryFilesByPath(row) {
      this.files.currentPage = 1;
      this.files.pageSize = 10;
      this.searchForm.path = row.path + "/" + row.name;
      this.queryFiles();
    },
    handleDelete(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.http.post("/client/file/delete", row).then(res => {
          if (res.data.flag == true) {
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000
            });
          } else {
            this.$notify({
              title: "失败",
              message: "删除失败",
              type: "error",
              duration: 2000
            });
          }
          this.queryFiles();
        });
      });
    },
    batchDelete() {
      let data = [];
      if (this.viewsSwitching) {
        this.selectedFiles.forEach(file => {
          data.push(file);
        });
      } else {
        data = this.multipleSelection;
      }
      const ts = data;
      // console.log(ts);
      if (ts.length == 0) {
        this.$notify({
          title: "提示",
          message: "请选择文件｜文件夹",
          type: "warning",
          duration: 2000
        });
        return;
      }
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.http.post("/client/file/batch-delete", ts).then(res => {
          if (res.data.flag == true) {
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000
            });
          } else {
            this.$notify({
              title: "失败",
              message: "删除失败",
              type: "error",
              duration: 2000
            });
          }
          this.files.currentPage = 1;
          this.queryFiles();
        });
      });
    },
    searchByAbsolutePath(path) {
      this.files.currentPage = 1;
      this.files.pageSize = 10;
      this.searchForm.path = path;
      this.queryFiles();
    },
    searchByPath(path, index) {
      var arr = [];
      for (var i = 0; i < this.files.paths.length; i++) {
        if (i <= index) {
          arr.push(this.files.paths[i]);
        }
      }
      this.files.currentPage = 1;
      this.files.pageSize = 10;
      this.searchForm.path = this.files.homePath + "/" + arr.join("/");
      this.queryFiles();
    },
    handleCreateFold() {
      this.$refs.createFoldRef.showCreateFold({ path: this.files.currentPath });
    },
    handleCreateFileFoldSuccess() {
      this.queryFiles();
    },
    handleUploadSuccess(params) {
      this.queryFiles();
    },
    handleUploadFile() {
      this.$refs.fileUploadRef.showFileUpload({ path: this.files.currentPath });
    },
    handleDownload(row) {
      const MAX_DOWNLOAD_SIZE = 1 * 1024 * 1024 * 1024;
      if (row.type === "FILE") {
        if (row.fileSize > MAX_DOWNLOAD_SIZE) {
          this.$notify({
            title: "下载失败",
            message: "下载的文件大小不能超过1GB",
            type: "error",
            duration: 2000
          });
          return;
        }
        window.location.href =
          "/client/file/download?path=" + row.path + "&name=" + row.name;
      } else if (row.type === "FOLD") {
        let params = {
          path: row.path,
          fileNames: [row.name]
        };
        this.http
          .post("/client/file/packageDownload", params, {
            responseType: "blob"
          })
          .then(res => {
            // console.log(res);
            let blob = res.data;
            let title = res.headers["content-disposition"].split(
              "filename="
            )[1];
            const download_url = window.URL.createObjectURL(blob);
            const eleLink = document.createElement("a");
            eleLink.href = download_url;
            eleLink.download = title;
            document.body.appendChild(eleLink);
            eleLink.click();
            window.URL.revokeObjectURL(download_url);
          });
      }
    },
    handleUploadClosed(params) {},
    restFiles() {
      this.files = {
        data: [],
        total: 0,
        currentPage: 0,
        pageSize: 10,
        homePath: undefined,
        prevPath: undefined,
        paths: undefined,
        currentPath: undefined
      };
    },
    handleCompress() {
      let data = [];
      if (this.viewsSwitching) {
        this.selectedFiles.forEach(file => {
          data.push(file);
        });
      } else {
        data = this.multipleSelection;
      }
      this.compressionList = data;
      if (this.compressionList.length == 0) {
        this.$notify({
          title: "提示",
          message: "请选择要压缩的文件",
          type: "warning",
          duration: 2000
        });
        return;
      }
      this.compressionDialog = true;
    },
    compressionFn() {
      if (this.compressQuery.compressionName == undefined) {
        this.$notify({
          title: "提示",
          message: "请输入压缩包名称",
          type: "warning",
          duration: 2000
        });
        return;
      }
      if (this.compressionList.length == 0) {
        this.$notify({
          title: "提示",
          message: "请选择要压缩的文件",
          type: "warning",
          duration: 2000
        });
        return;
      }
      let datas = {
        path: this.compressionList[0].path,
        name: this.compressQuery.compressionName,
        keepOriginalFile: this.compressQuery.switchCompression,
        fileData: this.compressionList.map(item => {
          return { name: item.name, type: item.type };
        })
      };
      this.http.post("/client/file/fileCompressed", datas).then(response => {
        if (response.data.flag == true) {
          this.$notify({
            title: "成功",
            message: "压缩成功",
            type: "success",
            duration: 2000
          });
          this.queryFiles();
        } else {
          this.$notify({
            title: "失败",
            message: response.data.msg,
            type: "error",
            duration: 2000
          });
        }
      });
      this.compressionDialog = false;
    },
    removeFileFromCompressionList(index) {
      const removedItem = this.compressionList[index];
      this.compressionList.splice(index, 1);
      this.selectedFiles.delete(removedItem.name);
      if (!this.viewsSwitching) {
        const tableSelection = this.$refs.fileTables.store.states.selection;
        const newSelection = tableSelection.filter(
          item => item.name !== removedItem.name
        );
        this.$refs.fileTables.clearSelection();
        newSelection.forEach(item =>
          this.$refs.fileTables.toggleRowSelection(item, true)
        );
      } else {
        this.files.data = this.files.data.map(item => {
          if (item.name === removedItem.name) {
            item.isCheck = false;
          }
          return item;
        });
      }
      this.multipleSelection = this.multipleSelection.filter(
        item => item.name !== removedItem.name
      );
    },
    // 设置表格row的class
    tableRowClassName({ row }) {
      if (row.disabled) {
        return "disabled";
      }
      if (row.type === "FOLD") {
        return "folder-item";
      }
      return "";
    },
    initDragAndDrop() {
      // table表格视图的拖拽
      if (!this.viewsSwitching) {
        const fileItems = document.querySelectorAll(
          ".el-table__body .file-name-draggable"
        );

        fileItems.forEach(item => {
          item.setAttribute("draggable", "true");

          item.addEventListener("dragstart", e => {
            const row = item.closest("tr");
            const tbody = row.parentNode;
            const rowIndex = Array.from(tbody.children).indexOf(row);
            e.dataTransfer.setData("text/plain", rowIndex);
            e.dataTransfer.setData("application/x-file-transfer", "true");
          });
        });
        // 为文件夹添加放置事件
        const folderRows = document.querySelectorAll(
          ".el-table__body tr.folder-item"
        );
        folderRows.forEach(row => {
          row.addEventListener("dragover", e => {
            e.preventDefault();
            e.stopPropagation();
            row.classList.add("drag-over");
          });

          row.addEventListener("dragleave", e => {
            e.preventDefault();
            e.stopPropagation();
            row.classList.remove("drag-over");
          });
          row.addEventListener("drop", e => {
            if (!this.isDragging) {
              e.preventDefault();
              e.stopPropagation();
              row.classList.remove("drag-over");
              if (
                e.dataTransfer.types.includes("application/x-file-transfer")
              ) {
                const sourceIndex = parseInt(
                  e.dataTransfer.getData("text/plain")
                );
                const targetIndex = Array.from(row.parentNode.children).indexOf(
                  row
                );
                const sourceItem = this.files.data[sourceIndex];
                const targetFolder = this.files.data[targetIndex];
                if (
                  sourceItem &&
                  targetFolder &&
                  targetFolder.type === "FOLD" &&
                  sourceItem.name !== targetFolder.name
                ) {
                  this.isDragging = true;
                  this.moveFileToFolder(sourceItem, targetFolder)
                    .then(() => {
                      this.isDragging = false;
                    })
                    .catch(() => {
                      this.isDragging = false;
                    });
                }
              }
            }
          });
        });
      } else {
        // 卡片视图的拖拽
        const cardItems = document.querySelectorAll(".switch-item");
        cardItems.forEach((card, idx) => {
          const iconElement = card.querySelector(".icon");
          if (iconElement) {
            iconElement.setAttribute("draggable", "true");
            iconElement.addEventListener("dragstart", e => {
              e.dataTransfer.setData("text/plain", idx);
              e.dataTransfer.setData("application/x-file-transfer", "true");
            });
            // 如果是文件夹，添加放置事件
            const isFolder = iconElement.querySelector(".el-icon-folder");
            if (isFolder) {
              card.addEventListener("dragover", e => {
                e.preventDefault();
                e.stopPropagation();
                card.classList.add("drag-over");
              });
              card.addEventListener("dragleave", e => {
                e.preventDefault();
                e.stopPropagation();
                card.classList.remove("drag-over");
              });
              card.addEventListener("drop", e => {
                if (!this.isDragging) {
                  e.preventDefault();
                  e.stopPropagation();
                  card.classList.remove("drag-over");
                  if (
                    e.dataTransfer.types.includes("application/x-file-transfer")
                  ) {
                    const sourceIndex = parseInt(
                      e.dataTransfer.getData("text/plain")
                    );
                    const sourceItem = this.files.data[sourceIndex];
                    const targetFolder = this.files.data[idx];
                    if (
                      sourceItem &&
                      targetFolder &&
                      targetFolder.type === "FOLD" &&
                      sourceItem.name !== targetFolder.name
                    ) {
                      this.isDragging = true;
                      this.moveFileToFolder(sourceItem, targetFolder)
                        .then(() => {
                          this.isDragging = false;
                        })
                        .catch(() => {
                          this.isDragging = false;
                        });
                    }
                  }
                }
              });
            }
          }
        });
      }
    },

    moveFileToFolder(sourceItem, targetFolder) {
      const actionText =
        sourceItem.type === "FOLD" ? "移动此文件夹" : "移动此文件";
      return this.$confirm(
        `确认要${actionText}【${sourceItem.name}】到文件夹【${
          targetFolder.name
        }】吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          // 构建请求参数;
          const datas = {
            path: sourceItem.path,
            moveFile: sourceItem.name,
            targetFile: targetFolder.name
          };
          return this.http
            .post("/client/file/fileMove", datas)
            .then(res => {
              if (res.data.success) {
                this.$message({
                  message: "移动成功",
                  type: "success"
                });
              } else {
                this.$message({
                  message: res.data.message || "移动失败",
                  type: "error"
                });
              }
              this.isDragging = false;
              this.queryFiles();
            })
            .catch(err => {
              this.$message({
                message: "移动失败",
                type: "error"
              });
              this.isDragging = false;
              this.queryFiles();
            });
        })
        .catch(() => {
          // 用户取消操作或发生错误时，重置拖拽状态
          this.isDragging = false;
        });
    },
    showRecycleBin() {
      this.recycleBinView = true;
      this.loadRecycleBinData();
    },

    // 隐藏回收站
    hideRecycleBin() {
      this.recycleBinView = false;
    },

    loadRecycleBinData() {
      this.recycleBinLoading = true;
      this.http
        .post("/client/fileDelete/page", {
          pageSize: 10,
          currentPage: 1
        })
        .then(res => {
          if (res.status === 200) {
            this.recycleBinData = res.data.data.rows;
          }
          this.recycleBinLoading = false;
        })
        .catch(error => {
          this.recycleBinLoading = false;
        });
    },

    // 还原文件
    restoreFile(row, type) {
      const actionText = type ? "还原文件" : "彻底删除";
      this.$confirm(`确认要${actionText} "${row.fileName}" 吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 调用恢复文件接口
        this.http.get(`/client/fileDelete/restore/${row.id}`).then(res => {
          if (res.data.flag === true) {
            this.$message({
              message: type ? "文件还原成功" : "彻底删除成功",
              type: "success"
            });
            this.showRecycleBin();
          } else {
            this.$message({
              message: "文件还原失败",
              type: "error"
            });
          }
        });
      });
    },
    permanentDelete(row) {
      this.$confirm(
        `确认要永久删除 "${row.fileName}" 吗？此操作无法撤销！`,
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$message.success(`已永久删除文件: ${row.name}`);
          // 实际项目中需要调用API永久删除文件
          // 删除成功后从回收站数据中移除
          const index = this.recycleBinData.findIndex(
            item => item.name === row.name
          );
          if (index > -1) {
            this.recycleBinData.splice(index, 1);
          }
        })
        .catch(() => {
          // 用户取消操作
        });
    }
  },
  created() {
    this.queryFiles();
  }
};
</script>
<style scoped lang="scss">
.switch {
  overflow: hidden;
  width: 88%;
  margin: 0 auto;
}

.switch .switch-item {
  float: left;
  width: 17%;
  height: 265px;
  margin-left: 20px;
  margin-bottom: 20px;
}

.switch .switch-item .check {
  position: absolute;
  top: 6px;
  left: 12px;
}

.switch .switch-item .icon {
  width: 100%;
  height: 200px;
  padding-top: 20px;
  text-align: center;
  font-size: 88%;
  /* background-color: red; */
}

.switch .switch-item .switch-item-bottom {
  display: flex;
  justify-content: right;
  font-size: 12px;
}

.icon-size {
  font-size: 150px;
  font-weight: 300;
}

.is-slurm {
  cursor: pointer;
  color: blue;
  text-decoration: underline;
}

.compression-dialog {
  .fileName {
    align-items: center;
    margin-bottom: 20px;

    .label {
      font-weight: bold;
      margin-right: 10px;
      width: 100px;
    }
  }

  .file-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;

    .label {
      font-weight: bold;
      margin-right: 10px;
    }

    .file-tag {
      background-color: #f0f0f0;
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }

  .switch-container {
    display: flex;
    align-items: center;

    .label {
      font-weight: bold;
      margin-right: 10px;
    }
  }
}
</style>
<style lang="scss">
.file-name-draggable {
  cursor: move;
  padding: 5px 0;

  &:hover {
    background-color: #f5f7fa;
  }
}
.drag-over {
  background-color: #e6f7ff !important;
  border: 1px dashed #409eff;
}
.switch-item {
  &.drag-over {
    background-color: #e6f7ff;
    border: 1px dashed #409eff;
  }

  .icon {
    cursor: move;
  }
}
.is-always-shadow {
  &:hover {
    background-color: #f5f7fa;
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/project2/components/file-transfer/file.vue